import type { LucideIcon } from 'lucide-react';
import {
  LayoutDashboard,
  Users,
  CreditCard,
  FileText,
  PiggyBank,
  Calendar,
  UsersRound,
  Settings,
  UserCog,
  User,
} from 'lucide-react';
import { normalizeUserRole, type UserRole } from '@/lib/roles';

export type NavItem = {
  label: string;
  icon: LucideIcon;
  href: string;
  description: string;
  roles: UserRole[];
};

export const MAIN_NAV_ITEMS: NavItem[] = [
  {
    label: 'Dashboard',
    icon: LayoutDashboard,
    href: '/dashboard',
    description: 'View your dashboard overview',
    roles: ['admin', 'hr', 'finance', 'audit', 'secretary', 'employee'],
  },
  {
    label: 'Employees',
    icon: Users,
    href: '/employees',
    description: 'Manage employee information',
    roles: ['admin', 'hr'],
  },
  {
    label: 'Payroll',
    icon: CreditCard,
    href: '/payroll',
    description: 'Process and manage payroll',
    roles: ['admin', 'finance', 'hr', 'audit', 'secretary'],
  },
  {
    label: 'Payslips',
    icon: FileText,
    href: '/payslips',
    description: 'View and manage payslips',
    roles: ['admin', 'finance', 'hr', 'audit', 'secretary', 'employee'],
  },
  {
    label: 'Leave Management',
    icon: Calendar,
    href: '/leave',
    description: 'Manage employee leave requests',
    roles: ['admin', 'hr', 'employee'],
  },
  {
    label: 'Advances',
    icon: PiggyBank,
    href: '/loans',
    description: 'Manage employee loans',
    roles: ['admin', 'finance', 'employee'],
  },
];

export const SETTINGS_NAV_ITEMS: NavItem[] = [
  {
    label: 'Team',
    icon: UsersRound,
    href: '/team',
    description: 'Manage team settings',
    roles: ['admin'],
  },
  {
    label: 'User Management',
    icon: UserCog,
    href: '/users',
    description: 'Manage system users',
    roles: ['admin'],
  },
  {
    label: 'Profile',
    icon: User,
    href: '/profile',
    description: 'View profile and change password',
    roles: ['admin', 'hr', 'finance', 'audit', 'secretary', 'employee'],
  },
  {
    label: 'Settings',
    icon: Settings,
    href: '/settings',
    description: 'Configure system settings',
    roles: ['admin', 'hr'],
  },
];

export function filterNavByRole(
  items: NavItem[],
  role: string | undefined | null
): NavItem[] {
  const normalized = normalizeUserRole(role);
  return items.filter((item) => item.roles.includes(normalized));
}
